import { useState } from "react";
import "./ForgotPassword.css";

const API = import.meta.env.VITE_API_URL;

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [msg, setMsg] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setMsg("");
    setLoading(true);

    try {
      const res = await fetch(`${API}/auth/forgot-password`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email }),
      });

      const data = await res.json();
      setMsg(data.message || "If the email exists, a reset link has been sent.");
    } catch {
      setMsg("Unable to process request at this time.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="fp-wrapper">
      <form className="fp-card" onSubmit={submit}>
        <h2>Forgot Password</h2>

        <p className="fp-info">
          Enter your registered email address to receive a reset link.
        </p>

        <input
          type="email"
          className="fp-input"
          placeholder="Registered email here"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
        />

        <button type="submit" className="fp-btn" disabled={loading}>
          {loading ? "Sending…" : "Send Reset Link"}
        </button>

        {msg && <div className="fp-msg">{msg}</div>}
      </form>
    </div>
  );
}
